export function productContactBox() {



    const box = document.getElementById('productContactBox');
    if (!box) return;

    const button = document.getElementById('contactBoxTitle');
    const content = document.getElementById('contactBoxContent');

    if (!button || !content) return;

    let clickFlag = false;

    const toggle = (e) => {

        // Stop event from bubbling to parent elements
        if (e) {
            e.preventDefault();
            e.stopPropagation();
            e.stopImmediatePropagation();
        }

        if (clickFlag) return;

        clickFlag = true;

        const isExpanded = button.getAttribute('aria-expanded') === 'true';

        content.classList.toggle('active');
        button.classList.toggle('active');

        button.setAttribute('aria-expanded', (!isExpanded).toString());

        setTimeout(() => {
            clickFlag = false;
        }, 300);
    };

    button.addEventListener('click', toggle, true);

    button.addEventListener('keydown', (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
            toggle(e);
        }
    });
}